import { type RequestPolicy } from 'urql';

import { useLoyaltyProfileId } from '../useLoyaltyProfileId';
import { useHasUnseenChallengesQuery } from './GraphQL/HasUnseenChallenges.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useHasUnseenChallenges = (
  requestPolicy: RequestPolicy = 'cache-only',
) => {
  const loyaltyProfileId = useLoyaltyProfileId();

  const [response] = useHasUnseenChallengesQuery({
    pause: !loyaltyProfileId,
    requestPolicy,
  });

  return Boolean(response.data?.hasUnseenChallenges.hasUnseenChallenges);
};
